import Heroe from './Heroe';

export default Heroe;
